import { InjectionToken } from '@angular/core';
import { ADMIN_ROUTE_PATHS } from 'core/constants/admin-route-paths';

export interface ProfilePageConfig {
  readonly homeRoute: string;
  readonly homeLabel: string;
  readonly profileRoute: string;
  readonly profileEditRoute: string;
  readonly showQuickActions: boolean;
}

export const DEFAULT_PROFILE_PAGE_CONFIG: ProfilePageConfig = {
  homeRoute: ADMIN_ROUTE_PATHS.dashboard,
  homeLabel: 'Dashboard',
  profileRoute: ADMIN_ROUTE_PATHS.profile,
  profileEditRoute: ADMIN_ROUTE_PATHS.profileEdit,
  showQuickActions: true,
};

export const CANTEEN_PROFILE_PAGE_CONFIG: ProfilePageConfig = {
  homeRoute: '/dashboard',
  homeLabel: 'Painel',
  profileRoute: '/profile',
  profileEditRoute: '/profile/edit',
  showQuickActions: false,
};

export const PROFILE_PAGE_CONFIG = new InjectionToken<ProfilePageConfig>(
  'PROFILE_PAGE_CONFIG',
  {
    factory: () => DEFAULT_PROFILE_PAGE_CONFIG,
  },
);
